var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import "phaser";
import { __charactername, __uigameplayname } from "@/lib/variables";
var SplashScene = /** @class */ (function (_super) {
    __extends(SplashScene, _super);
    function SplashScene() {
        return _super.call(this, { key: "SplashScene" }) || this;
    }
    SplashScene.prototype.init = function (params) {
        this.params = params;
    };
    SplashScene.prototype.preload = function () {
        this.load.image("logo", "".concat(__uigameplayname, "/super-hero-arena-logo.png"));
        this.load.image("logo_char", "".concat(__charactername, "/Char_Sonic.png"));
    };
    SplashScene.prototype.create = function () {
        this.scene.start("LoadingScene", this.params);
    };
    return SplashScene;
}(Phaser.Scene));
export default SplashScene;
